<template>
  <div class="header">
    <el-row :gutter="20"  class="headerColor">
      <el-col :span="12">
          <el-image style="height: 40px; margin-right:30px;" class="cursorPointer" :src="siteInformation.logo" fit="contain" @click="routerIndex"/>
          <!-- <h3 style="cursor: unset;width:180px;overflow: hidden;text-overflow: ellipsis;" :title="siteInformation.siteName"><template v-if="siteInformation.siteName">{{ siteInformation.siteName }}</template></h3> -->
          <h3 class="line" @click="jump('/')">首页</h3>
          <!-- <h3 @click="jump('/')">源素通</h3>
          <h3 @click="jump('https://www.jqweike.cn')">金桥大赛</h3> -->
      </el-col>
      <template v-if="router.currentRoute.value.path !== '/CourseOnlyVideo'">
        <el-col :span="6" :offset="1">
          <el-input class="inputDeep" v-model="searchStore.keyWord" size="large" placeholder="搜索课程" :suffix-icon="Search" :maxlength="20" clearable @keydown.enter="routerCourseList"/>
        </el-col>
        <!-- <el-col :span="1"><el-button style="width: 100%;" type="primary" size="large" @click="routerCourseList">搜索</el-button></el-col> -->
        <el-col :span="1" :offset="1" style="text-align: right;"><el-avatar :src="loginStore.headImg"  v-if="loginStore.isLogin"/></el-col>
        <el-col :span="2" style="cursor: pointer;display: flex;" v-if="loginStore.isLogin">
          <el-dropdown trigger="click" style="overflow: hidden;">
            <div style="display: flex;overflow: hidden;">
              <el-tooltip v-if="loginStore.username.length > 8" class="box-item" effect="dark" :content="loginStore.username" placement="top">
                <p class="el-dropdown-link">{{ loginStore.username}}</p>
              </el-tooltip>
              <p v-else class="el-dropdown-link">{{ loginStore.username}}</p>
              <div style="margin-top: 14px;"><el-icon class="el-icon--right"><arrow-down /></el-icon></div>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item v-if="loginStore.roleId == 5 || loginStore.roleId == 7" @click="routerToIndividualCenter">管理中心</el-dropdown-item>
                <el-dropdown-item v-else @click="routerToIndividualCenter">个人中心</el-dropdown-item>
                <!-- <el-dropdown-item @click="routerToIndividualCenter">账号设置</el-dropdown-item> -->
                <el-dropdown-item @click="showReset">重置密码</el-dropdown-item>
                <el-dropdown-item @click="showCancelAccount">账号注销</el-dropdown-item>
                <el-dropdown-item @click="exitAccount">退出</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </el-col>
        <el-col :span="1" v-else class="login" @click="showLogin">登录</el-col>
      </template>
    </el-row>

    <!-- 机构选择 -->
    <el-dialog
      v-model="showIf"
      width="30%"
      :append-to-body="true"
      :modal-append-to-body="true"
      class="agency-select-dialog"
    >
      <!-- //内容 -->
      <el-form
          ref="agencyFormRef"
          :model="agencyForm"
          :rules="agencyRules"
          class="demo-ruleForm"
          status-icon
          label-position="top"
          hide-required-asterisk="true"
      >
        <el-form-item prop="IPAddress" :show-message="false">
          <template #label>
            <h3>
              <span class="OrangeColor">*</span> 当前
              <span class="OrangeColor">IP</span> 检测到多个机构信息，请从下列机构中选择
            </h3>
          </template>
          <el-select
              v-model="agencyForm.agencyId"
              filterable
              size="large"
              style="width: 80%; padding-left: 11%"
              placeholder="请选择"
          >
            <el-option
                v-for="item in agencyList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label-width="0">
          <el-row justify="space-around" style="margin-top: 50px; width: 100%">
            <el-col :span="9">
              <el-button
                  size="large"
                  style="width: 100%"
                  type="info"
                  @click="cancelView"
              >
                取消
              </el-button>
            </el-col>
            <el-col :span="9">
              <el-button
                  size="large"
                  style="width: 100%"
                  type="primary"
                  background-color="#E65833"
                  @click="submitForm(agencyFormRef)"
              >
                确定
              </el-button>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script setup>
import {
  ref,
  shallowRef,
  inject,
  onMounted,
  onDeactivated,
  onUnmounted,
  getCurrentInstance, reactive,
  watchEffect,
  nextTick,
  onActivated
} from "vue";
import { Search, ArrowDown } from "@element-plus/icons-vue";
import {useRoute, useRouter} from "vue-router";
import useLogin from "@/stores/login";
import login from "@views/login";
import ResetPassword from "@views/login/ResetPassword";
import CancelAccount from "@views/login/CancelAccount";
import { ElMessage, ElMessageBox } from "element-plus";
import useSearch from "@/stores/search";
import logo from "@images/logo.png";
import {clickAgency, getAgencyExpire, getAgencyIdByIpScope} from "@/request/api";
import Theme from "@/components/Theme/Theme.vue"
import useSiteInformation from "@/stores/siteInformation"
import white from "@/assets/image/header-bg/white.png";
import orange from "@/assets/image/header-bg/orange.png";
import blue from "@/assets/image/header-bg/blue.png";
import pink from "@/assets/image/header-bg/pink.png";
import green from "@/assets/image/header-bg/green.png";
import gray from "@/assets/image/header-bg/gray.png";

const siteInformation = useSiteInformation()
const searchStore = useSearch();
const loginStore = useLogin();
const router = useRouter();
const searchInput = ref("");

const Reload = inject("Reload", true);
const route = useRoute()

const routerIndex = () => {
  if(router.currentRoute.value.path === '/CourseOnlyVideo'){ return }
  router.push({ path: "/" });
};
onMounted(() => {
  // searchInput.value = localStorage.getItem("keyword") == undefined ? "" : localStorage.getItem("keyword");
  // setTimeout(()=>{
  //   routerCourseList();
  // },500)
  // });
  // onUpdated(() => {
  //   router.push({
  //     path: "/searchList",
  //     query: {
  //       keyword: searchStore.keyWord,
  //     },
  //   });
  if (loginStore.isLogin) {
    if (loginStore.agencyId) {
      loginStore.showVisible = false;
    } else {
      loginStore.showVisible = true;
    }
  } else {
    loginStore.showVisible = false;
  }
  const res1 = judgeIp();
});

const jump = (url) =>url === '/'? router.push({ path: "/" }) : window.open(url)

const bgMap = {white,orange,blue,pink,green,gray}
watchEffect(()=>{
  nextTick(()=>{
    const header = document.querySelector('.el-header')
    if(siteInformation.topBarImg){
      header.style.setProperty(
        'background',
        `url(${bgMap[siteInformation.topBarImg]}) center bottom no-repeat`,
        'important'
      )
      header.style.setProperty('background-size', 'cover', 'important')
    }else{
      const container = document.querySelector('.el-container.is-vertical')
      container.style.setProperty('background-color', '#000', 'important')
      header.style.setProperty('background-color', 'rgba(75, 107, 174,0.6)', 'important')
      header.style.setProperty('background-image', 'none', 'important')
      header.style.setProperty('box-shadow', '0 0 12px #000', 'important')
    }
  })
})

const { proxy } = getCurrentInstance();

const showIf=ref(false)
const agencyForm = reactive({
  agencyId: undefined,
});
const agencyRules = reactive({
  agencyId: [{ required: true, message: "请选择机构", trigger: "change" }],
});
const agencyFormRef = ref();
const agencyList = ref(null);

const cancelView = () => {
  showIf.value = false;
};
const submitForm = async (formEl) => {
  if (!formEl) return;
  await formEl.validate((valid, fields) => {
    if (valid) {
      let agencyId = agencyForm.agencyId;
      clickAgency({ id: agencyId }).then((res) => {
        if (res.status == 10000) {
          ElMessage.success("确定成功");
          showIf.value = false;
          loginStore.agencyId = agencyId;
          loginStore.code = res.data;
          router.go(0)
        } else {
          ElMessage.error(res.msg);
        }
      });
    } else {
      console.log("error submit!", fields);
    }
  });
};

//判断当前ip数据哪个机构
const judgeIp = async ()=>{
  if(loginStore.isLogin || !['/index','/courseDetails'].includes(window.location.pathname)){
    return
  }
  getAgencyIdByIpScope({agencyId:loginStore.agencyId}).then(res=>{
    if(res.status === 10000){
      if(res.data){
        if(res.data.length > 1){
          agencyList.value = res.data;
          showIf.value = true;
        }else if(res.data.length == 1){

          if(loginStore.agencyId){
            let agencyId = res.data[0].value
            loginStore.agencyId = agencyId;
            loginStore.code = res.data[0].code;
          }else {
            let agencyId = res.data[0].value
            loginStore.agencyId = agencyId;
            loginStore.code = res.data[0].code;
            // router.go(0)
          }


        }else {
          loginStore.agencyId = undefined;
        }
      }
    }
  })
}

const routerCourseList = () => {
  setTimeout(() => {
    if (searchStore.keyWord === "") {
      ElMessage({
        message: "请输入搜索内容",
        type: "warning",
      });
      return;
    }

    const loading = proxy.$loading();
    getAgencyExpire({ agencyId: loginStore.agencyId }).then((res) => {
      loading.close();
      if (res.status == 10000) {
        if (res.data) {
          ElMessageBox.confirm(
            '<b style="color: red;font-size: 15px">授权已到期，请联系管理员！客服电话：400 073 0887 转 2</b>',
            "过期警告",
            {
              distinguishCancelAndClose: true,
              dangerouslyUseHTMLString: true,
              confirmButtonText: "确定",
              cancelButtonText: "取消",
            }
          )
            .then(() => {})
            .catch((action) => {});
        } else {
          router.push({
            path: "/searchList",
            query: {
              keyword: searchStore.keyWord,
            },
          });
          Reload();
        }
      } else {
        loading.close();
      }
    });
  }, 500);
};
const showLogin = () => {
  const url = router.resolve({ path: '/login'}).href
  window.open(url, "_self")
  // loginStore.showVisible = true;
  // loginStore.component = shallowRef(login);
  // loginStore.$patch({
  //   showVisible: true,
  //   component: shallowRef(login),
  // });
};
const showReset = () => {
  loginStore.showVisible = true;
  loginStore.component = shallowRef(ResetPassword);
};
const showCancelAccount = () => {
  loginStore.showVisible = true;
  loginStore.component = shallowRef(CancelAccount);
};
const exitAccount = () => {
  loginStore.isLogin = false;
  loginStore.token = "";
  loginStore.code = "";
  loginStore.agencyId = undefined;
  loginStore.userId = undefined;
  loginStore.roleId = -1;
  loginStore.username = undefined;
  (loginStore.headImg =
    "https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"),
    ElMessage({
      message: "退出账号成功",
      type: "success",
    });
  // router.push({
  //   path: "/",
  // });
  const url = router.resolve({ path: '/login'}).href
  window.open(url, "_self")
  // router.go(0);
};
const routerToIndividualCenter = () => {
  router.push({
    path: "/individualCenter",
  });
};
const ThemeRef = ref()
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
@import "@/styles/element-variables.scss";
.yellowColor {
  color: $OrangeColor;
  cursor: pointer;
}
:deep(.el-input__wrapper) {
  // background-color: $backgroundColor;
  background-color: rgb(250, 250, 250);
  border: 1px solid var(--el-color-primary);
  box-shadow: 0 0 0 1px var(--el-color-primary);
}
:deep(.el-text) {
  position: relative;
  top: 28px;
  left: 24px;
  cursor: pointer;
}

/* 消除小三角 */
.el-popper.is-light .el-popper__arrow::before {
  display: none;
}

.el-row{
  height:68px;
  display: flex;
  align-items: center;
  width: 1200px;
  margin: 0 auto !important;
}

.el-col-12{
  display: flex;
  align-items: center;
  height: 70px;
  .line::after{
    position: absolute;
    bottom: 0;
    left: -3px;
    content: '';
    width: 120%;
    height: 1px;
    background-color: #fff;
  }
  h3{
    position: relative;
    line-height: 40px;
    color:#fff;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    margin: 0 20px;
    white-space: nowrap;
  }
}

.inputDeep{
  height: 30px;
  :deep(.el-input__inner)::placeholder{
    color: #a6a6a6 !important;
  }
  :deep(.el-input__wrapper){
    border-radius: 10px;
    outline: none;
    border: 0;
    box-shadow: none !important;
    .el-icon{
      color: #a6a6a6 !important;
    }
  }
}

.el-dropdown-link{
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  color: #fff;
}

.login{
  line-height: 30px;
  border-radius: 5px;
  background-color: #E65833;
  color:#fff;
  cursor: pointer;
  white-space: nowrap;
  font-weight: 100;
}

/* 添加全局弹窗样式 */
:deep(.agency-select-dialog) {
  .el-overlay {
    position: fixed;
    z-index: 2999 !important;
  }

  .el-dialog__wrapper {
    position: fixed;
    z-index: 3000 !important;
  }

  .el-dialog {
    margin-top: 15vh !important;
  }
}

/* 确保弹窗内容正确显示 */
.el-dialog {
  .el-form {
    .el-select {
      width: 100%;
    }
  }
}
</style>
